import globalStore from '@/services/global.state';
import {getAdjustAttribution} from '@/utils/adjust';
import {http, getAttribution} from '@utils';
import DeviceInfo from 'react-native-device-info';
import {SafeAny} from '@components/types';

export const sendCode = (userPhone: string) => {
  return http.post('app/sendCode', {userPhone});
};

export const userLogin = async (
  userPhone: string,
  code: string,
  userInviteCode?: string,
  isLogin: boolean = true,
) => {
  const date: {[k: string]: any} = {
    userPhone,
    code,
    userInviteCode,
    ...getAttribution(userInviteCode),
  };
  if (!isLogin && globalStore.isWeb && !userInviteCode) {
    date.userInviteCode = localStorage.getItem('invitationCode') || undefined;
  }

  if (globalStore.isWeb) {
    const attr = getAdjustAttribution();
    if (attr && attr.adid) {
      date.isReport = attr?.tracker_name !== 'Organic';
      date.adid = attr?.adid || '';
    }
  }

  const deviceCode = globalStore.isWeb
    ? getAdjustAttribution()?.adid
    : await DeviceInfo.getAndroidId();

  date.deviceCode = deviceCode;
  if (getAdjustAttribution()?.gps_adid) {
    date.gpsAdid = getAdjustAttribution()?.gps_adid;
  }

  return http.post<
    null,
    {
      token: string;
      isNewUser: boolean;
    }
  >('app/userLoginNew', date, {
    headers: {
      deviceCode,
    },
  });
};

export const passwordLogin = async (userPhone: string, password: string) => {
  const deviceCode = globalStore.isWeb
    ? getAdjustAttribution()?.adid
    : await DeviceInfo.getAndroidId();
  const gpsAdid = getAdjustAttribution()?.gps_adid;
  const data = {} as SafeAny;
  if (gpsAdid) {
    data.gpsAdid = gpsAdid;
  }

  return http.post<null, string>('app/password/login', {
    userPhone,
    password,
    deviceCode,
    ...data,
  });
};

export const updatePassword = (password: string, otpCode: string) => {
  return http.post<null, string>('app/user/set/password', {
    password,
    code: otpCode,
  });
};
